/*
  Keeps bottom-pinned buttons (cart drawer checkout, mobile buy bar) tappable when a
  third-party element is fixed over the bottom edge, e.g. Shopify's theme preview bar
  or a chat bubble. Sets --milla-bottom-obstruction on <html>; CSS lifts the buttons by it.
*/
(() => {
  const root = document.documentElement;
  let current = 0;

  const isOurs = (element) => element.closest('cart-drawer, milla-sticky-atc');

  const fixedAncestor = (element) => {
    let node = element;
    while (node && node !== document.body && node !== root) {
      if (getComputedStyle(node).position === 'fixed') return node;
      node = node.parentElement;
    }
    return null;
  };

  const somethingPinnedIsOpen = () =>
    document.querySelector('cart-drawer.active') || document.querySelector('milla-sticky-atc:not([hidden])');

  const measure = () => {
    if (!somethingPinnedIsOpen()) return 0;
    const y = window.innerHeight - 2;
    let height = 0;
    [0.5, 0.85].forEach((share) => {
      const hit = document.elementFromPoint(window.innerWidth * share, y);
      if (!hit || isOurs(hit)) return;
      const fixed = fixedAncestor(hit);
      if (!fixed || isOurs(fixed)) return;
      const bounds = fixed.getBoundingClientRect();
      const covered = window.innerHeight - bounds.top;
      if (covered > 0 && covered < window.innerHeight * 0.4) height = Math.max(height, covered);
    });
    return Math.ceil(height);
  };

  const update = () => {
    const next = measure();
    if (next === current) return;
    current = next;
    root.style.setProperty('--milla-bottom-obstruction', `${next}px`);
  };

  const schedule = (delays) => delays.forEach((delay) => setTimeout(update, delay));

  const watch = () => {
    const observer = new MutationObserver(() => schedule([50, 400, 900]));
    document.querySelectorAll('cart-drawer, milla-sticky-atc').forEach((element) => {
      observer.observe(element, { attributes: true, attributeFilter: ['class', 'hidden'] });
    });
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 150);
    });
    schedule([1000, 3000]);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
